var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniLogoEdgeColour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 608.5952,
    y1: 424.3476,
    x2: 391.8505,
    y2: 576.1138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    className: "st6",
    d: "M632.26,500.31c0-72.69-59.12-133.78-131.65-133.78c-72.52,0-132.86,61.09-132.86,133.78 c0,72.69,60.34,133.17,132.86,133.17C573.13,633.48,632.26,573,632.26,500.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149349932401931957310000006885296313321506474_",
    gradientUnits: "userSpaceOnUse",
    x1: 881.6461,
    y1: 789.5957,
    x2: 634.1407,
    y2: 962.9008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149349932401931957310000006885296313321506474_)"
    },
    d: "M758.78,614.13 c-42.5,92.61-120.18,160.15-245.4,171.2l124.92,183.52H1000L758.78,614.13z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066507250642766096150000016202299317773120429_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.2969,
    y1: 673.0261,
    x2: 155.5268,
    y2: 838.8142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066507250642766096150000016202299317773120429_)"
    },
    d: "M469.67,783.52 c-119.97-24.44-188.35-83.03-228.43-169.4l-124.42,169.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126306705394561063110000008251469265531526305_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.458,
    y1: 37.0224,
    x2: 118.6761,
    y2: 210.5211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126306705394561063110000008251469265531526305_)"
    },
    d: "M487.07,215.04L362.35,31.15H0 L241.69,386.2C281.32,301.16,365.07,224.36,487.07,215.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029044982248667902510000001674125967448948115_",
    gradientUnits: "userSpaceOnUse",
    x1: 839.804,
    y1: 164.4425,
    x2: 610.0121,
    y2: 325.3445
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029044982248667902510000001674125967448948115_)"
    },
    d: "M534.26,217.15 c113.97,17.14,177.63,78.26,222.84,166.44l119.62-166.44"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogoEdgeColour);
export default __webpack_public_path__ + "static/media/mini-logo-edge-colour.409c9695583813e66add9fb4717a2e13.svg";
export { ForwardRef as ReactComponent };